import React from 'react';
import { Button } from './ui/button';
import { Github, ArrowRight } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="py-20 px-6">
      <div className="container mx-auto max-w-4xl">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-blue-600 to-blue-800 p-12 md:p-16 text-center text-white shadow-2xl">
          <div className="absolute inset-0 bg-grid-white/10"></div>
          <div className="relative z-10 space-y-8">
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight">
              Ready to see what your agents are doing?
            </h2>
            <p className="text-xl text-blue-100 max-w-2xl mx-auto">
              Join developers building transparent, observable AI agents.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button
                size="lg"
                variant="secondary"
                asChild
                className="bg-white text-blue-600 hover:bg-gray-100 text-lg px-8 py-6 rounded-lg transition-all hover:scale-105"
              >
                <a href="https://github.com/getagentd/agentd-py" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2">
                  <Github className="h-5 w-5" />
                  <span>Get Started</span>
                  <ArrowRight className="h-5 w-5" />
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;